import { UISimulation } from '@/components/help/UISimulation';
import { SimShell } from './simShell';

const D = 1900;

// Managing alerts — 3 frames: alert list -> filter by site -> dismiss read.
function ALList(): JSX.Element {
  return (
    <SimShell step={1} total={3} title="Alert feed">
      <ul className="space-y-1 text-[11px]">
        {[
          ['pipeline_stuck', 'border-error/40 text-error'],
          ['deploy_failed', 'border-error/40 text-error'],
          ['re_illustrate_complete', 'border-accent/40 text-accent'],
        ].map(([type, cls]) => (
          <li
            key={type}
            className={'rounded border bg-dash-surface px-3 py-1.5 font-mono ' + cls}
          >
            {type}
          </li>
        ))}
      </ul>
    </SimShell>
  );
}

function ALFilter(): JSX.Element {
  return (
    <SimShell step={2} total={3} title="Filter">
      <div className="flex flex-wrap gap-1.5 text-[11px]">
        {['Unread only', 'Errors', 'Include global'].map((t, i) => (
          <span
            key={t}
            className={
              'rounded px-2 py-0.5 border ' +
              (i === 1
                ? 'border-accent/40 bg-accent/10 text-accent'
                : 'border-dash-border text-dash-secondary')
            }
          >
            {t}
          </span>
        ))}
      </div>
      <div className="mt-1.5 text-[10px] font-mono text-dash-muted">
        ?q= and ?type= persist in the URL
      </div>
    </SimShell>
  );
}

function ALDismiss(): JSX.Element {
  return (
    <SimShell step={3} total={3} title="Mark + dismiss">
      <div className="rounded border border-success/40 bg-success/10 px-3 py-2 text-xs">
        <div className="text-dash-primary">All read alerts dismissed.</div>
        <div className="text-[10px] font-mono uppercase text-success mt-0.5">
          unread alerts stay put
        </div>
      </div>
    </SimShell>
  );
}

export function AlertsSimulation(): JSX.Element {
  return (
    <UISimulation
      steps={[
        { frame: <ALList />, label: 'Grouped by severity', duration: D },
        { frame: <ALFilter />, label: 'Filter by type and site', duration: D },
        { frame: <ALDismiss />, label: 'Dismiss what you have read', duration: D },
      ]}
    />
  );
}
